import { render } from "./asideBar.vue?vue&type=template&id=18a134e6"
import script from "./asideBar.vue?vue&type=script&lang=js"
export * from "./asideBar.vue?vue&type=script&lang=js"

import "./asideBar.vue?vue&type=style&index=0&id=18a134e6&lang=css"
script.render = render

export default script